import React, { useRef, useEffect, useState } from "react";
import "./App.scss";
import Loader from "./components/Shared/Widgets/Loader/Loader.js";
import SideBarComponent from "./components/Shared/Widgets/SideBar/sideBar";
import RoutesConfig from "./config/routesConfig.jsx";
import { useSelector } from "react-redux";
import Counts from "./components/Counts/counts.jsx";

function App() {
  const appBarRef = useRef(null);
  const [topMargin, setTopMargin] = useState(0);
  const isLoading = useSelector((state) => state.loading.isLoading);

  useEffect(() => {
    if (appBarRef.current) {
      setTopMargin(appBarRef.current.offsetHeight);
    }
  }, []);

  return (
    <div className="App">
      {isLoading && <Loader />}
      <SideBarComponent ref={appBarRef} />
      <div className="main-container p-4">
        {/* <Counts />÷ */}
        <RoutesConfig />
      </div>
    </div>
  );
}
export default App;
